import { Table } from 'components/Elements';
import { UpdateStatus } from './UpdateStatus';
import { Link } from 'react-router-dom';

export const SearchResultsTable = ({ results }) => {
  // If no results, we display a friendly message
  if (!results || results.length === 0) {
    return <div className="text-white">No matching results found for search.</div>;
  }

  const columns = [
    {
      title: 'Customer',
      field: '',
      Cell({ entry: { id, firstName, lastName, photo } }) {
        return (
          <Link
            to={`/app/customers/${id}`}
            className="flex flex-row items-center space-x-2 justify-start"
          >
            <img
              src={photo || '/default-avatar.png'}
              alt="Avatar"
              className="w-4 h-4 rounded-full"
            />
            <span>
              {firstName} {lastName}
            </span>
          </Link>
        );
      },
    },
    {
      title: 'Email',
      field: 'email',
      Cell({ entry: { email } }) {
        return <span>{email}</span>;
      },
    },
    {
      title: 'Status',
      field: 'status',
      Cell({ entry: { id, status } }) {
        return <UpdateStatus id={id} status={status} />;
      },
    },
  ];

  return <Table data={results} columns={columns} />;
};
